export const GA_MEASUREMENT_ID = 'G-0M5RW50E62';
export function blogPageTitle(post) { return post ? (post.seoTitle || post.title) + ' | Blog | Devssoft' : 'Blog | Devssoft'; }
export function sendPageView(title, pathname) {
  if (typeof window.gtag !== 'function' || !title || !pathname) return false;
  window.gtag('event', 'page_view', {
    send_to: GA_MEASUREMENT_ID,
    page_title: title,
    page_location: window.location.origin + pathname,
    page_path: pathname
  });
  return true;
}
